// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"852961fe","879":"d2aa5758"}[chunkId] + ".chunk.js";
};